// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"639":"categories","920":"devices","945":"dashboard"}[chunkId] + "." + {"639":"6c791f12","920":"6d47da51","945":"df2f1abd"}[chunkId] + ".css";
};